import { RootState } from '@app/index';

export const selectIsModalOpen = ({ shareAccess }: RootState) => shareAccess.isModalOpen;
